// extracted by mini-css-extract-plugin
module.exports = {"MyProfilePaneHolder":"MyProfilePaneContentHolder_MyProfilePaneHolder__1iLmj","MyProfilePane":"MyProfilePaneContentHolder_MyProfilePane__kMwUq"};